// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"_variables__pc_only___-GWmH","sp_only":"_variables__sp_only___Ttq0z"};